export interface PhoneGateSession {
  config?: {
    phoneCapture?: { enabled?: boolean };
  };
  user?: { hasPhoneNumber?: boolean };
}

const skipKey = (linkId: string) => `raas-phone-skip:${linkId}`;

function storage(): Storage | null {
  try {
    return typeof sessionStorage === "undefined" ? null : sessionStorage;
  } catch {
    return null;
  }
}

export function isPhoneSkipped(linkId: string): boolean {
  return storage()?.getItem(skipKey(linkId)) === "1";
}

export function skipPhoneForLink(linkId: string): void {
  storage()?.setItem(skipKey(linkId), "1");
}

export function clearPhoneSkip(linkId: string): void {
  storage()?.removeItem(skipKey(linkId));
}

/**
 * Prompt only when the partner turned capture on, the user has no canonical
 * phone, and they have not skipped this link. Insert the screen after CIP
 * (or after confirm when CIP is skipped) and before the irreversible step.
 */
export function shouldPromptPhone(
  session: PhoneGateSession | null | undefined,
  linkId?: string
): boolean {
  if (session?.config?.phoneCapture?.enabled !== true) return false;
  if (session?.user?.hasPhoneNumber === true) return false;
  if (linkId && isPhoneSkipped(linkId)) return false;
  return true;
}
